import AgTypography from '../../../stories/Styles/AgTypography';
import AgProfileSectionTable, { ProfileSectionTableData } from '../../../stories/Components/AgSimpleTable';
import { useIntl } from 'react-intl';
import AgToggle from '../../../stories/Components/AgToggle';
import { AgColor } from '../../../stories/Styles/AgColor';
import { Divider } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { ApiIdentityOut } from '@agunity/api-v4/build/data-contracts';
import { SUCCESS_STATUS } from '../../../Constants';
import AgTextField from '../../../stories/Components/AgTextField';
import { checkDuplicatedEmail } from '../../Users/redux';
import { setEmailExists } from '../../../redux/slices/staff';
import isEmail from 'validator/lib/isEmail';
import { useAppDispatch } from '../../../redux/hooks';
import { HasOnBlurProps, ValidationListPersonalProps } from '../AddStaff/AddStaff';

export interface SettingsProps {
  email?: string;
  identity?: ApiIdentityOut;
  setPersonalDetails?: Dispatch<SetStateAction<ApiIdentityOut | undefined>>;
  setHasPassword?: Dispatch<SetStateAction<boolean>>;
  hasPassword?: boolean;
  editAccess?: boolean;
  setValidationListPersonal?: Dispatch<SetStateAction<ValidationListPersonalProps>>;
  validationListPersonal?: ValidationListPersonalProps;
  setHasOnBlur?: Dispatch<SetStateAction<HasOnBlurProps>>;
  showPersonalDetailsError?: boolean;
}

const Index = (
  {
    email,
    identity,
    setPersonalDetails,
    setHasPassword,
    hasPassword,
    editAccess,
    setValidationListPersonal,
    validationListPersonal,
    setHasOnBlur,
    showPersonalDetailsError
  }: SettingsProps
) => {
  const messages = useIntl().formatMessage;
  const dispatch = useAppDispatch();

  const tableData: ProfileSectionTableData[] = [
    {
      name: messages({ id: 'EMAIL' }),
      value: email
    }
  ];

  const checkEmail = async () => {
    if (!identity?.email) return;
    try {
      const result = await dispatch(checkDuplicatedEmail(identity?.email));
      if (result.status === SUCCESS_STATUS) {
        if (result.data) {
          // result.data === true, means email exists
          dispatch(setEmailExists(true));
        } else {
          // else, email doesn't exist
          dispatch(setEmailExists(false));
        }
      }
      if (setValidationListPersonal && validationListPersonal) {
        // validation
        let errorCaption: string[] = [];
        if (identity?.email && !isEmail(identity?.email)) {
          errorCaption.push(messages({ id: 'MEMBER_EMAIL_INVALID_CAPTION' }));
        }
        if (identity?.email && result.data) {
          errorCaption.push(messages({ id: 'MEMBER_EMAIL_CHECK' }));
        }
        if (identity?.email.length > 100) {
          errorCaption.push(messages({ id: 'MEMBER_EMAIL_MAX_100_CAPTION' }));
        }
        setValidationListPersonal((prevState) => ({
          ...prevState,
          email: errorCaption
        }));
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  const renderEmail = () => {
    return editAccess ?
      (<AgTextField
        optionalText
        label={messages({
          id: 'MEMBER_PERSONAL_DETAILS_CONTACT_INFO_EMAIL'
        })}
        formStyle={{ flex: 1 }}
        value={identity?.email || ''}
        error={
          Boolean(validationListPersonal?.email.length) &&
          (showPersonalDetailsError)
        }
        caption={
          Boolean(validationListPersonal?.email.length) &&
          (showPersonalDetailsError)
            ? validationListPersonal?.email
            : ''
        }
        onChange={(e) => {
          if (setPersonalDetails && identity) {
            setPersonalDetails({ ...identity, email: e.target.value });
          }
        }}
        onBlur={() => {
          checkEmail();
          setHasOnBlur &&
          setHasOnBlur((prevHasOnBlur) => ({
            ...prevHasOnBlur,
            email: true
          }));
        }}
      />)
      : (
        <AgProfileSectionTable tableData={tableData} />
      );
  };

  return (
    <AgTypography
      style={{
        padding: '24px 16px',
        display: 'grid',
        gap: '16px'
      }}
    >
      <AgTypography
        style={{ color: AgColor.grey6 }}
        contentStyle={'AP.H5.UPPERCASE.Bold'}
        message={messages({ id: 'MEMBER_SETTING_TITLE' })}
      />
      <AgTypography
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <AgTypography
          contentStyle={'AP.Paragraph.Small.Regular'}
          message={messages({ id: 'MEMBER_SETTING_TEXT_1' })}
          style={{
            width: '320px',
            color: AgColor.grey7
          }}
        />
        <AgToggle
          disabled={!editAccess}
          checked={hasPassword}
          onChange={() => {
            if (setHasPassword) {
              setHasPassword(prevState => !prevState);
            }
            if (setPersonalDetails && identity) {
              setPersonalDetails({ ...identity, hasPassword: !hasPassword });
            }
          }}
        />
      </AgTypography>
      {renderEmail()}
      <AgTypography
        style={{ color: AgColor.grey7 }}
        contentStyle={'AP.Paragraph.Small.Regular'}
        message={messages({ id: 'MEMBER_SETTING_TEXT_2' })}
      />
      <Divider sx={{ margin: '16px 0' }} />
    </AgTypography>
  );
};

export default Index;